import {
  ASSET_TYPE_BY_KEY,
  ASSET_TYPES,
  type AssetType,
  type AssetTypeConfig,
} from '@/config/fleetConstants'

export function isAssetType(value: unknown): value is AssetType {
  return typeof value === 'string' && value in ASSET_TYPE_BY_KEY
}

/** API payloads may use asset_type, vehicle_type, or type — resolve to a canonical AssetType. */
export function resolveAssetType(
  row: { asset_type?: unknown; vehicle_type?: unknown; type?: unknown } | null | undefined,
  fallback?: AssetType,
): AssetType | undefined {
  for (const key of ['asset_type', 'vehicle_type', 'type'] as const) {
    const raw = row?.[key]
    if (isAssetType(typeof raw === 'string' ? raw.trim().toLowerCase() : raw)) {
      return (typeof raw === 'string' ? raw.trim().toLowerCase() : raw) as AssetType
    }
  }
  return fallback
}

export function getAssetTypeConfig(type: string | null | undefined): AssetTypeConfig | null {
  if (!type) return null
  const normalized = type.toLowerCase() as AssetType
  return ASSET_TYPE_BY_KEY[normalized] ?? null
}

export function getAssetMapIcon(type: string | null | undefined): string {
  return getAssetTypeConfig(type)?.mapIcon ?? 'directions_car'
}

export function getAssetPlaceholder(
  type: string | null | undefined,
  context: keyof AssetTypeConfig['placeholders'],
): string {
  const config = getAssetTypeConfig(type)
  if (config) return config.placeholders[context]
  return ASSET_TYPES[1].placeholders[context]
}

export const assetTypeSelectOptions = ASSET_TYPES.map((t) => ({ value: t.key, text: t.label }))

/** VaSelect may bind a string or `{ value, text }` — always coerce to the option value string. */
export function coerceVaSelectValue(val: unknown): string {
  if (val == null) return ''
  if (typeof val === 'string') return val.trim()
  if (typeof val === 'number' || typeof val === 'boolean') return String(val).trim()
  if (typeof val === 'object' && !Array.isArray(val)) {
    const o = val as Record<string, unknown>
    if (typeof o.value === 'string') return o.value.trim()
    if (typeof o.value === 'number') return String(o.value).trim()
  }
  return ''
}
